import { Injectable } from '@angular/core';
import { Cart, NotificationAlert } from '@box-types';
import { InfoNotificationWidgetData } from '@box-shared/components/info-notification-wrapper/info-notification-wrapper.types';
import { InfoNotificationWrapperComponent } from '@box-shared/components';
import { NotificationsService } from '@box-core/services/notifications.service';
import { NotificationRef } from '@box-core/components';
import { CartService } from './cart.service';

@Injectable({ providedIn: 'root' })
export class ZeroContributionInMinPriceNotificationService {
  private seenProductIds = new Set<string>();
  private notificationRefMap: Map<string, NotificationRef> = new Map();
  private notificationAlert: NotificationAlert;
  private suppressInitialCartNotifications = false;

  constructor(private notificationsService: NotificationsService) {}

  public setNotificationAlert(alert: NotificationAlert): void {
    if (!this.isNotificationAlertEligible(alert)) return;
    this.notificationAlert = alert;
  }

  public getNotificationAlert(): NotificationAlert {
    return this.notificationAlert;
  }

  public hasSeenNotificationForProduct(productId: string): boolean {
    return this.seenProductIds.has(productId);
  }

  public showNotificationIfEligible(productId: string): NotificationRef | void {
    if (this.hasSeenNotificationForProduct(productId)) return;
    if (!this.notificationAlert) return;
    if (this.suppressInitialCartNotifications) return;

    const data: InfoNotificationWidgetData = {
      title: this.notificationAlert.title,
      message: this.notificationAlert.message,
      autoClose: true
    };

    const notificationRef = this.notificationsService.addNotification(InfoNotificationWrapperComponent, {
      data
    });

    this.notificationRefMap.set(productId, notificationRef);
    this.seenProductIds.add(productId);

    return notificationRef;
  }

  private isNotificationAlertEligible(alert: NotificationAlert): boolean {
    return !!(alert?.title || alert?.message);
  }

  public showNotificationForZeroContributionInMinPriceProduct(product: {
    id: string;
    hasZeroContributionInMinPrice: boolean;
  }) {
    if (this.suppressInitialCartNotifications) return;

    if (!product.hasZeroContributionInMinPrice || this.seenProductIds.has(product.id)) return;

    this.showNotificationIfEligible(product.id);
  }
}
